import Vue from 'vue';
var GlobalEventBus = new Vue();
export default GlobalEventBus;
